import {
    BarElement,
    CategoryScale,
    Chart as ChartJS,
    Filler,
    Legend,
    LineElement,
    LinearScale,
    PointElement,
    Title,
    Tooltip,
    ArcElement,          // Add ArcElement
    DoughnutController,  // Add DoughnutController
} from 'chart.js'
import React, { Fragment } from 'react'
import { Bar, Line, Pie, Doughnut
 } from 'react-chartjs-2'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Header } from '~/components/header'
import { Sidebar } from '~/components/sidebar'
import { Loading } from '../../../components/loader/loader'
import { convertADtoBS, getBillId, getInvoiceId } from '../../../helper/function/abstract'
import { AbstractAdminDashboardComponent, mapStateToProps } from './abstract'
import ProgressBar from '@ramonak/react-progress-bar'
ChartJS.register(BarElement, CategoryScale, LinearScale, PointElement, LineElement, ArcElement, DoughnutController, Title, Tooltip, Filler, Legend)


const chart_options = (title) => ({
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        legend: {
            position: 'top',
        },
        title: {
            display: true,
            text:  title ,
        },
    },
})



const status = ['Draft', 'Sent', 'Unpaid', 'Partialy Paid', 'Paid']
class AdminDashboardComponent extends AbstractAdminDashboardComponent {
    constructor(props) {
        super(props)
        this.state = {
            ...this.state,
        }
    }

    getUserCount() {
        const { t } = this.props
        const { userCount } = this.state
        return (
            <div className="col-md-12">
                <div class="todo-box">
                    <h4>{t('common:usercount')}</h4>
                    <div class="box-content-list form-group">
                        <div className="chart-content">
                            <Bar
                                options={chart_options('User Count')}
                                data={{
                                    labels: ["User Count"],
                                    datasets: [
                                        {
                                            label: 'Student',
                                            translate: t('todo:student'),
                                            fill: true,
                                            data: [userCount.student],
                                            backgroundColor: 'rgb(255, 99, 132)',
                                        },
                                        {
                                            label: 'Employee',
                                            translate: t('common:employee'),
                                            fill: true,
                                            data: [userCount.employee],
                                            backgroundColor: 'rgb(54, 162, 235)',
                                        },
                                    ],
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    getEmployeeAttendance() {
        const { t } = this.props
        const { employeeAttendance} = this.state
        const {studentAttendance} =this.state
        return (
            <div className="col-md-12">
                <div class="todo-box">
                    <h4>{t('sidebar:attendance')}</h4>
                    <div className='row'>
                    <div class="box-content-list form-group col-md-6">
                        <div className="chart-content">
                            <Pie
                                options={chart_options('Employee Attendance')}
                                data={{
                                    labels: [
                                        'Total Employee',
                                        'Present Employee',
                                      ],
                                      datasets: [{
                                        label: 'Emplyee Attendance',
                                        data: [employeeAttendance.totalEmployee, employeeAttendance.presentEmployee],
                                        backgroundColor: [
                                          'rgb(255, 99, 132)',
                                          'rgb(54, 162, 235)',
                                        ],
                                        hoverOffset: 4
                                      }]
                                }}
                            />
                        </div>
                    </div>
                    <div class="box-content-list form-group col-md-6">
                        <div className="chart-content">
                            <Pie
                                options={chart_options('Student Attendance')}
                                data={{
                                    labels: [
                                        'Total Student',
                                        'Present Student',
                                      ],
                                      datasets: [{
                                        label: 'Student Attendance test',
                                        data: [studentAttendance.totalStudents, studentAttendance.presentStudents],
                                        backgroundColor: [
                                          'rgb(255, 99, 132)',
                                          'rgb(54, 162, 235)',
                                        ],
                                        hoverOffset: 4
                                      }]
                                }}
                            />
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        )
    }

    getBookCount() {
        const { t } = this.props
        const { book} = this.state
        return (
            <div className="col-md-12">
                <div class="todo-box">
                    <h4>{t('common:booksstatus')}</h4>

                    <div class="box-content-list form-group">
                        <div className="chart-content">
                            <Doughnut
                                options={chart_options("Book Status")}
                                data={{
                                    labels: [
                                        'Total Books',
                                        'Book Issued',
                                      ],
                                      datasets: [{
                                        label: 'Books Status',
                                        data: [book.totalBooks, book.bookIssued == null ? '0' : book.bookIssued],
                                        backgroundColor: [
                                          'rgb(255, 99, 132)',
                                          'rgb(54, 162, 235)',
                                        ],
                                        hoverOffset: 4
                                      }]
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    getEvents() {
        const { t } = this.props
        const { events } = this.state
        if (events.length > 0) {
            return (
                <div className="col-md-12">
                    <div class="todo-box">
                        <h4>{t('common:events')}</h4>
                        <div className="box-content-list form-group">
                            <ul>
                            {events.slice(0, 5).map((item, index) => {

                                return (
                                    <li key={index} className="p-3">
                                        {item.title} - {item.description}

                                    </li>
                                )
                            })}
                            </ul>
                        </div>
                    </div>
                </div>
            )
        }
    }

    getHolidays() {
        const { t } = this.props
        const { holidays } = this.state
        if (holidays.length > 0) {
            return (
                <div className="col-md-12">
                    <div class="todo-box">
                        <h4>{t('common:holidays')}</h4>
                        <div className="box-content-list form-group">
                            <ul>
                            {holidays.slice(0, 5).map((item, index) => {

                                return (
                                    <li key={index} className="p-3">
                                        {item.title} - {item.description}

                                    </li>
                                )
                            })}
                            </ul>
                        </div>
                    </div>
                </div>
            )
        }
    }

    getExams() {
        const { t } = this.props
        const { exams } = this.state
        if (exams.length > 0) {
            return (
                <div className="col-md-12">
                    <div class="todo-box">
                        <h4>{t('common:exams')}</h4>
                        <div className="box-content-list form-group">
                            <ul>
                            {exams.slice(0, 5).map((item, index) => {

                                return (
                                    <li key={index} className="p-3">
                                        {item.title} - {item.description}

                                    </li>
                                )
                            })}
                            </ul>
                        </div>
                    </div>
                </div>
            )
        }
    }

    getPackage(){
        
        const { t } = this.props
        if(this.state.packageData !=null){
            return (
                <div className="col-md-12">
                    <div className="todo-box p-3">
                        <div className="progress-wrap">
                        <h6 className="line-title">{this.state.packageData != null ? this.state.packageData.name : t('subscription:package_status')} :</h6>
                        <hr />
                        {this.state.progressStatus.map((item, index) => {
                            let completed = (item.completed / item.max) * 100
                            if (item.isStorage) {
                                completed = ((item.completed / (1024 * 1024 * 1024)).toFixed(2) / (item.max / 1024).toFixed(2)) * 100
                            }
                            return (
                                <div className="progress-content mb-4" key={index}>
                                    <div className="progress-label">
                                        <p>{t(item.translate)}</p>
                                    </div>
                                    {item.max != 0 && (
                                        <div className="x-progress-bar">
                                            <ProgressBar bgcolor={item.bgcolor} completed={completed} isLabelVisible={false} />
                                        </div>
                                    )}
                                    <div className="progress-value">
                                        <p>
                                            {item.max != 0 && (
                                                <span>
                                                    {item.isStorage && (
                                                        <span>
                                                            {(item.completed / (1024 * 1024 * 1024)).toFixed(2)} / {(item.max / 1024).toFixed(2)} GB
                                                        </span>
                                                    )}
                                                    {!item.isStorage && (
                                                        <span>
                                                            {item.completed} / {item.max}
                                                        </span>
                                                    )}
                                                </span>
                                            )}
                                            {item.max == 0 && (
                                                <span style={{ background: item.bgcolor }} className="progress-tag">
                                                    {item.isStorage && <span>{(item.completed / (1024 * 1024 * 1024)).toFixed(2)} GB</span>}
                                                    {!item.isStorage && item.completed}
                                                </span>
                                            )}
                                        </p>
                                    </div>
                                </div>
                            )
                        })}
                        </div>
                    </div>
                </div>
    
            )

        }
       
        

    }



    render() {
        const { t } = this.props
        const { report, incomeExpense } = this.state
        return (
            <div className="main-page">
                <Sidebar id="dashboard" />
                <Loading status={this.state.loading} text="Loading" />
                <div className="main-content">
                    <Header />
                    <div className="main-head-option">
                        <div className="row clearfix">
                            <div className="col-md-12 float-left">
                                <h5 className="main-title heading5">{t('accounting:dashboard')}:</h5>
                            </div>
                        </div>
                    </div>
                    <div className="main-box">

                    <div className="row">
                                <div className="col-md-8">
                                    <div className="row">
                                    {this.state.userCount != null && this.getUserCount()}
                                    {this.state.employeeAttendance != null && this.getEmployeeAttendance()}
                                    {this.state.packageData != null && this.getPackage()}
                                    {this.state.book != null && this.getBookCount()}
                                    
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="row">
                                      {this.getEvents()}
                                      {this.getHolidays()}
                                      {this.getExams()}
                                      
                                      
                              


                                    </div>
                                </div>

                            </div>
                    </div>
                </div>
            </div>
        )
    }
}

const AdminDashboard = withTranslation()(connect(mapStateToProps)(AdminDashboardComponent))

export { AdminDashboard }
